document.addEventListener('DOMContentLoaded', () => {
  $('.js-select2').select2({
    closeOnSelect: true
  })
})
